export default "__VITE_ASSET__CsW20Q8B__"